import apiService from '../service/apiService';

// eslint-disable-next-line import/prefer-default-export
export async function getUsersApi(params, nextToken) {
  if (nextToken) {
    params.nextToken = nextToken;
  }
  return apiService.searchUsers(params);
}
